module.exports = {
    title: "客户案例_世界500强快消品牌信赖之选_惠合科技",
    description: "惠合科技与可口可乐、玛氏箭牌、农夫山泉、雀巢、伊利等100+知名快消品牌落地了超1000场传统渠道数字营销活动。",
    keywords: "快消品营销案例,开箱扫码案例,陈列自检案例,业代巡拍案例,到店核销案例,一元乐享案例"
}